import { render, staticRenderFns } from "./WorkingOnIt.vue?vue&type=template&id=528dd252&scoped=true&"
import script from "./WorkingOnIt.vue?vue&type=script&lang=js&"
export * from "./WorkingOnIt.vue?vue&type=script&lang=js&"
import style0 from "./WorkingOnIt.vue?vue&type=style&index=0&id=528dd252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528dd252",
  null
  
)

export default component.exports